import DateFormat from './dateFormat';
import { format as f } from 'd3-format';
import chartUtils from './chart-utils';

export var getTooltipValue = function getTooltipValue(tooltipSettings, data) {

    var tipValue = data[tooltipSettings.Id];

    if (tipValue == null) tipValue = data[tooltipSettings.TipField];

    var aggregationType = tooltipSettings.AggregationType;

    if (aggregationType.trim().toLowerCase() == "unknown") aggregationType = '';

    if (aggregationType.trim().length == 0 && Number(tipValue) <= 1) tipValue = data[tooltipSettings.TipField];

    return tipValue == null ? "--" : tipValue;
};

var isNumber = function isNumber(inputValue) {
    var Regx = /^[-+]?[0-9]+\.*[0-9]*$/;
    return Regx.test(inputValue);
};

export var buildTooltipText = function buildTooltipText(tooltipConfig, data, defaultTipText, defaultTipValue, defaultTipAggregation, displayTotalRecords) {
    var text = null;
    var includeDefaultTip = true;

    if (tooltipConfig != null) text = tooltipConfig.TooltipText;

    if (defaultTipText == null) defaultTipText = '';

    if (text == null || text.trim().length == 0) {
        if (data["counter"] != null && displayTotalRecords == true) return defaultTipText + '<br /><span class="tip-header"># items:</span><span class="tip-value"> ' + data["counter"] + '</span>';

        return defaultTipText;
    }

    if (tooltipConfig != null && tooltipConfig.TooltipConfigs.length > 0) {
        for (var index = 0; index < tooltipConfig.TooltipConfigs.length; index++) {
            var tipItem = tooltipConfig.TooltipConfigs[index];

            if (defaultTipValue != null && tipItem.TipField == defaultTipValue && (tipItem.AggregationType == defaultTipAggregation || tipItem.AggregationType == "")) includeDefaultTip = false;

            var tipValue = data[tipItem.Id];
            if (isNumber(tipValue) || tipItem.TipField.toLowerCase().indexOf('date') > -1) {
                if (tipItem.ValueFormat.indexOf('/') > -1) {
                    tipValue = chartUtils.formatDate(tipValue, tipItem.ValueFormat);
                } else tipValue = chartUtils.format(tipValue, tipItem.ValueFormat, tipItem.CurrencySymbol, null, tipItem.BaseFormat, false, tipItem.TipField);
            }

            text = text.replace("{" + tipItem.TipField + "}", tipValue + " ");

            // Check for handling undefined for tootlip text
            if (text.trim() === "undefined") text = '';
        }

        text += "<br />";

        if (includeDefaultTip && defaultTipText != "") {
            text += defaultTipText;

            text += "<br />";
        }

        if (data["counter"] != null && displayTotalRecords == true) text += '<br /><span class="tip-header"># items:</span><span class="tip-value"> ' + data["counter"] + '</span>';
    }

    return text;
};

var formatNumber = function formatNumber(val, displayFormat, currencyPrefix, referenceValue, baseFormat, isDecimalPercentNumber, categoryField) {
    if (displayFormat == ',.f') displayFormat = ',.0f';

    if (val == null) return val;

    if (categoryField != null && categoryField.toLocaleLowerCase().indexOf('date') >= 0) {
        if (displayFormat != null && displayFormat != "") return formatDate(val, displayFormat);
    }

    if (isNaN(val)) return val;

    if ((displayFormat == null || displayFormat.trim().length == 0) && (currencyPrefix == null || currencyPrefix.trim().length == 0) && (baseFormat == null || baseFormat.trim().length == 0 || baseFormat == chartUtils.baseFormat.none)) return val.toString();

    var suffix = "";

    if (displayFormat != null && !isNaN(val) && displayFormat.toLocaleLowerCase() == "hms") return converttoHMS(val);

    if (displayFormat != null && !isNaN(val) && displayFormat.toLocaleLowerCase() == "ms") return converttoMS(val);

    if (currencyPrefix == null) currencyPrefix = "";

    if (displayFormat == null || displayFormat.trim().length == 0) displayFormat = ",.0f";

    if (displayFormat.indexOf("%") > -1 && displayFormat.indexOf("f") > -1) {
        displayFormat = displayFormat.split("%")[0];
        suffix = "%";
    }

    if (displayFormat.indexOf("f") > -1) {
        var fIndex = displayFormat.indexOf("f");
        if (fIndex > 0) {
            var decimals = displayFormat.charAt(fIndex - 1);
            if (isNaN(decimals)) val = val.toFixed(2);
        }
    }

    try {
        if (referenceValue == null) referenceValue = val;

        var format = f(displayFormat);
        var formattedValue = "";

        if (baseFormat != null) {
            switch (baseFormat.toLowerCase()) {
                case "k":
                    formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;
                    break;
                case "m":
                    formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;
                    break;
                case "b":
                    formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
                    break;
                case "d":
                    {
                        if (referenceValue >= 1000 && referenceValue < 1000000 || referenceValue > -1000000 && referenceValue <= -1000) formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;else if (referenceValue >= 1000000 && referenceValue < 1000000000 || referenceValue > -1000000000 && referenceValue <= -1000000) formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;else if (referenceValue >= 1000000000 || referenceValue <= -1000000000) formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
                    }
                    break;
            }
        }

        if (isDecimalPercentNumber) val = val * 100;

        if (formattedValue.length < 1) formattedValue = currencyPrefix + format(val) + suffix;

        if (formattedValue.length > 0) {
            if (val < 0) formattedValue = formattedValue.toString().replace("-", "(") + ")";
        }

        return formattedValue;
    } catch (e) {
        if (!formattedValue) return val;
        if (baseFormat != null) {
            switch (baseFormat.toLowerCase()) {
                case "k":
                    formattedValue = currencyPrefix + (val / 1000).toFixed(2).toLocaleString() + "K" + suffix;
                    break;
                case "m":
                    formattedValue = currencyPrefix + (val / 1000000).toFixed(2).toLocaleString() + "M" + suffix;
                    break;
                case "b":
                    formattedValue = currencyPrefix + (val / 1000000000).toFixed(2).toLocaleString() + "B" + suffix;
                    break;
                case "d":
                    {
                        if (referenceValue >= 1000 && referenceValue < 1000000 || referenceValue > -1000000 && referenceValue <= -1000) formattedValue = currencyPrefix + format((val / 1000).toFixed(2)) + "K" + suffix;else if (referenceValue >= 1000000 && referenceValue < 1000000000 || referenceValue > -1000000000 && referenceValue <= -1000000) formattedValue = currencyPrefix + format((val / 1000000).toFixed(2)) + "M" + suffix;else if (referenceValue >= 1000000000 || referenceValue <= -1000000000) formattedValue = currencyPrefix + format((val / 1000000000).toFixed(2)) + "B" + suffix;
                    }
                    break;
            }
        }

        if (isDecimalPercentNumber) val = val * 100;

        if (formattedValue.length < 1) formattedValue = currencyPrefix + val.toFixed(2).toLocaleString() + suffix;

        if (formattedValue.length > 0) {
            if (val < 0) formattedValue = formattedValue.toString().replace("-", "(") + ")";
        }
        return formattedValue;
    }
};

var converttoHMS = function converttoHMS(value) {
    var h = Math.floor(value / 3600);
    var m = Math.floor((value - h * 3600) / 60);
    var s = Math.floor(value - (h * 3600 + m * 60));
    return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
};

var converttoMS = function converttoMS(value) {
    var m = Math.floor(value / 60);
    var s = Math.floor(value - m * 60);
    return (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
};

var formatDate = function formatDate(value, format) {
    if (!format) return value;

    //make sure value is a string since we need to index into it
    value = '' + value;

    /*
    when date doesn't have a time stamp append a dummy time stamp
    for proper date cast in javascript
    */
    if (value.indexOf(":") == -1) value += " 00:00:00";

    var dateVal = value;

    if (Object.prototype.toString.call(value) != "[object Date]") {
        dateVal = new Date(value);
        if (dateVal == 'Invalid Date') dateVal = value;
    }

    return DateFormat.format.date(dateVal, format);
};